import uuidv1 from 'uuid/v1';
import axios from 'axios';
import config, { CONFIG_KEY_NAMES } from '../../config/config';
import REST_API_NAMES from '../../config/restApiNames';
import { store } from '../../index';
import moment from 'moment-timezone';
import getPartnerAsset, { DynamicAssetsKeys } from '../../../../assets';
const analyticsConstants = {
  screenName: 'screen',
  eventTypes: {
    controlEvent: 'ControlEvent',
    screenEvent: 'ScreenEvent',
    sessionEvent: 'SessionEvent',
    serviceEvent: 'APIEvent',
    redirectEvent: 'RedirectEvent',
  },
};

const AnalyticsContext = function(context) {
  context = context || {};

  Object.assign(
    this,
    {
      scope: '',
      eventName: '',
      carrierId: '',
      category: '',
      advancedProperties: {},
      properties: {},
      eventTime: '',
      identities: {},
      sourceType: '',
      channel: '',
      _stickyProp: [],
    },
    context
  );

  return this;
};
//method exposed to the consumers to initialize the common reporting properties
function createAnalyticsContext(functionsObj) {
  return new Analytics(functionsObj);
}
const Analytics = function(functionsObj) {
  this.context = new AnalyticsContext();
  this.getScreenName = functionsObj.getScreenName;
  this.dispatch = function() {
    let otherCampaignDetailsStr = window.sessionStorage.getItem('otherCampaignDetails');
    let otherCampaignDetails = {};
    if (otherCampaignDetailsStr) {
      otherCampaignDetails = JSON.parse(otherCampaignDetailsStr);
    }

    this.context.eventTime = Math.floor(new Date().getTime() / 1000);
    const storeData = store && store.getState();
    let localUniversalId = window.localStorage.getItem('universalId');
    let universalId = (storeData && storeData.callMeNow && storeData.callMeNow.atlasUniversalId) || localUniversalId;
    let localId = getDistinctId();
    let events_obj = {
      scope: config.KEY(CONFIG_KEY_NAMES.scope),
      carrier: config.KEY(CONFIG_KEY_NAMES.carrier),
      source: config.KEY(CONFIG_KEY_NAMES.mixpanelSource),
      api_key: config.KEY(CONFIG_KEY_NAMES.mixpanelApiKey),
      payload: {
        events: [
          {
            ...otherCampaignDetails,
            universalId,
            eventName: config.KEY(CONFIG_KEY_NAMES.scope) + '_' + this.context.eventName,
            category: this.context.category,
            eventTime: this.context.eventTime,
            carrierId: config.KEY(CONFIG_KEY_NAMES.carrier).toUpperCase(),
            sourceType: 'SHS-EXPERIENCES',
            endpointId: localId,
            time: moment().unix(),
            ...this.context.advancedProperties,
            ...this.context.properties,
            ...this.context.identities,
          },
        ],
      },
    };

    this.clearAdvancedProps();
    var payload = JSON.stringify(events_obj);

    return functionsObj.sendReportingEvent(payload);
  };
};
/**
 *
 * adds passed object on to the properties object within the context
 * @param {Object} propertiesObj
 * @returns {Object}
 */
Analytics.prototype.withCommonProps = function(propertiesObj) {
  return overwriteProperties.call(this, 'properties', propertiesObj);
};
/**
 *
 * adds passed object on to the advanvedProperties object within the context
 * @param {Object} propertiesObj
 * @returns {Analytics}
 */
Analytics.prototype.withAdvancedProps = function(propertiesObj) {
  return overwriteProperties.call(this, 'advancedProperties', propertiesObj);
};
Analytics.prototype.clearAdvancedProps = function() {
  this.context.advancedProperties = {};
};
const overwriteProperties = function(propertyName, propertiesObj) {
  var newContext = new AnalyticsContext(this.context);
  for (var key in propertiesObj) {
    if (propertiesObj[key]) {
      newContext[propertyName][key] = propertiesObj[key];
    } else {
      delete newContext[propertyName][key];
    }
  }
  this.context = newContext;
  return this;
};
/**
  sends a screen event to mixpanel
 */
Analytics.prototype.screenEvent = function() {
  this.context.eventName = analyticsConstants.eventTypes.screenEvent;
  return this.event();
};

//sends a control event to Mixpanel
Analytics.prototype.controlEvent = function() {
  this.context.eventName = analyticsConstants.eventTypes.controlEvent;
  return this.event();
};

//sends a session event to Mixpanel
Analytics.prototype.sessionEvent = function() {
  this.context.eventName = analyticsConstants.eventTypes.sessionEvent;
  return this.event();
};

//sends a api event to Mixpanel
Analytics.prototype.serviceEvent = function() {
  this.context.eventName = analyticsConstants.eventTypes.serviceEvent;
  return this.event();
};

Analytics.prototype.withCarriedId = function(carrierId) {
  this.context.carrierId = carrierId;
  return this;
};

Analytics.prototype.withCategory = function(category) {
  this.context.category = category;
  return this;
};
Analytics.prototype.createScoped = function(scopeName) {
  this.context.scope = scopeName;
  return this;
};

Analytics.prototype.withSourceType = function(source) {
  this.context.sourceType = source;
  return this;
};

//gets the browser type and browser version
const getBrowserNameAndVersion = function() {
  var ua = navigator.userAgent,
    tem,
    M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return 'IE ' + (tem[1] || '');
  }
  if (M[1] === 'Chrome') {
    tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
    if (tem !== null) {
      return tem
        .slice(1)
        .join(' ')
        .replace('OPR', 'Opera');
    }
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
  if ((tem = ua.match(/version\/(\d+)/i)) !== null) M.splice(1, 1, tem[1]);
  return { name: M[0], version: M[1] };
};

//helper method not exposed to consumer
Analytics.prototype.event = function() {
  if (typeof this.getScreenName === 'function') {
    this.withAdvancedProps({
      [analyticsConstants.screenName]: this.getScreenName(),
    });
  }
  return this.dispatch();
};
const getDistinctId = function() {
  let localId = window.localStorage.getItem('distinctId');
  if (!localId) {
    localId = uuidv1();
    window.localStorage.setItem('distinctId', localId);
  }
  return localId;
};
Analytics.prototype.withIdentity = function(propertiesObj) {
  for (var key in propertiesObj) {
    if (propertiesObj[key]) this.context.identities[key] = propertiesObj[key];
  }
  return this;
};

Analytics.prototype.withChannel = function(channel) {
  this.context.channel = channel;
  return this;
};
//updates properties object on the context with browsertype and browser version
Analytics.prototype.updateBeaconBrowserDetails = function() {
  let browserDetails = getBrowserNameAndVersion();
  return this.withCommonProps({
    browserType: browserDetails['name'],
    browerVersion: browserDetails['version'],
  });
};
const sendReportingEvent = (data) => {
  const headers = {
    headers: {
      'content-type': 'application/json',
    },
  };
  return axios.post(config.REST_URL(REST_API_NAMES.reporting), data, headers);
};
export const getScreenName = () => {
  const path = window.location.pathname;
  const getRoutePath = getPartnerAsset(DynamicAssetsKeys.expertSessionsPath);

  if (path.endsWith(getRoutePath)) return 'experiences';
  if (path.endsWith('feedback')) return 'feedback';
  if (path.endsWith('joinresearchpanel')) return 'joinresearchpanel';
  if (path.endsWith('unsubscribe')) return 'unsubscribe';
  if (path.endsWith('redirect')) return 'redirect';
  if (path.endsWith('onboarding')) return 'onboarding';
  if (path.endsWith('questionnaire')) return 'questionnaire';
  if (path.endsWith('result')) return 'result';
  console.error('could not find screen name for window value', window);
  return 'Unknown';
};
const functionsObj = {
  sendReportingEvent: sendReportingEvent,
  getScreenName: getScreenName,
};
let analyticsContext = createAnalyticsContext(functionsObj);

//initializing the context- occurs only once, during initial site load
analyticsContext
  .updateBeaconBrowserDetails()
  .createScoped('Experiences')
  .withCarriedId('VZ')
  .withCategory('Experiences')
  .withSourceType('Experiences')
  .withIdentity({ distinctId: getDistinctId() });
export default analyticsContext;
export { getDistinctId };



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/components/analytics/Analytics.js